import React, { Fragment, useState } from "react";
import {
  Typography,
  Box,
  Grid,
  CardMedia,
  Button,
  IconButton,
} from "@mui/material";
import colors from "../../../styles/colors";
import BreadCrumbs from "../../../components/BreadCrumbs/BreadCrumbs";
import { InputField } from "../../../components/Fields/TextField";
import { PrimaryButton } from "../../../components/Button/Button";
import {
  SuccessToaster,
  ErrorToaster,
} from "../../../components/Toaster/Toaster";
import CategoriesServices from "../../../apis/Marketplace/Categories/CategoriesServices";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { CloudUpload } from "@mui/icons-material";
import { Error } from "../../../components/UI/Error";
import { makeStyles } from "@mui/styles";
import { Close } from "@mui/icons-material";
import { baseUrl } from "../../../../axios";

const useStyles = makeStyles((theme) => ({
  rightLabel: {
    textAlign: "right",
    direction: "rtl",
  },
}));

function CreateCategory() {
  const [selectedImage, setSelectedImage] = useState("");
  const [imgPath, setImgPath] = useState("");
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  const classes = useStyles();
  const [fileInputKey, setFileInputKey] = useState(Date.now());

  const createCategory = async (formData) => {
    setLoading(true);
    try {
      let obj = {
        name: formData.name,
        name_ar: formData.nameInAr,
        picture: imgPath,
      };
      const { data, message } = await CategoriesServices.createcategory(obj);
      if (data === null) return;
      setTimeout(() => navigate("/marketplace/categories"), 1000);
      SuccessToaster(message);
    } catch (error) {
      ErrorToaster(error);
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const categoryPicture = async (image) => {
    const validImageTypes = ["image/png", "image/jpeg", "image/jpg"];
    if (!validImageTypes.includes(image?.type)) {
      ErrorToaster("Please upload a valid image file (PNG, JPEG, or JPG)");
    } else {
      try {
        let formData = new FormData();
        formData.append("imagePath", image);
        const { responseCode, data } = await CategoriesServices.uploadImage(
          formData
        );
        if (responseCode === 200) {
          setImgPath(data.imgPath);
          setFileInputKey(Date.now());
          setSelectedImage(data.imgPath);
        }
      } catch (error) {
        ErrorToaster(error);
      }
    }
  };

  const customLabelStyle = {
    textAlign: "right",
    direction: "rtl",
  };

  return (
    <Fragment>
      <Box
        sx={{
          backgroundColor: colors.lightGray,
          p: 3,
          borderRadius: "12px",
          // width: "calc(100vw - 370px)",
        }}
      >
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          spacing={1}
          sx={{ bgcolor: colors.white, p: 2, borderRadius: "12px" }}
        >
          <Grid item xs={6}>
            <Typography variant="body1" fontWeight="bold" color="initial">
              Create Category
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <BreadCrumbs currentPage={["Categories", "Create Category"]} />
          </Grid>
        </Grid>
        <Box sx={{ bgcolor: colors.white, p: 3, borderRadius: "12px", mt: 2 }}>
          <Typography
            component={"form"}
            onSubmit={handleSubmit(createCategory)}
          >
            <Grid
              container
              spacing={2}
              alignItems="center"
              justifyContent={selectedImage && "center"}
            >
              {/* Name in Eng */}
              <Grid item xs={12} md={6}>
                <InputField
                  label="Create Category"
                  register={register("name", {
                    required: "Please fill the field",
                  })}
                  error={errors?.name?.message}
                />
              </Grid>
              {/* Name in Arabic */}
              <Grid item xs={12} md={6}>
                <InputField
                  label="إنشاء فئة"
                  sx={{ direction: "rtl" }}
                  register={register("nameInAr", {
                    required: "Please fill the field",
                  })}
                  error={errors?.nameInAr?.message}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
                display={selectedImage ? "none" : "block"}
                sx={{ padding: "0 !important" }}
              >
                <input
                  type="file"
                  key={fileInputKey}
                  accept="image/*"
                  style={{
                    opacity: "0",
                    outline: "none",
                    background: "white",
                    cursor: "inherit",
                    display: "none",
                  }}
                  id="uploadImage"
                  onInput={(event) => {
                    categoryPicture(event.target.files[0]);
                  }}
                  {...register("image", {
                    required:
                      !imgPath || !selectedImage
                        ? "Please select image"
                        : false,
                  })}
                  error={errors?.image?.message}
                />
                <label
                  htmlFor="uploadImage"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    marginLeft: "15px",
                    paddingLeft: "15px",
                    border: errors?.image?.message
                      ? "1px solid #d32f2f"
                      : "1px solid #c4c4c4",
                    borderRadius: "6px",
                  }}
                >
                  <CloudUpload
                    sx={{
                      display: selectedImage ? "none" : "block",
                      fontSize: "38px",
                      color: errors?.image?.message
                        ? "#d32f2f"
                        : colors.primary,
                      cursor: "pointer",
                      "&:hover": {
                        color: colors.secondary,
                        transition: "0.3s ease-in-out",
                      },
                    }}
                  />
                  {selectedImage === "" && (
                    <Typography
                      sx={{
                        color: errors?.image?.message ? "#d32f2f" : colors.gray,
                      }}
                    >
                      {errors?.image ? errors?.image?.message : "Upload Image"}
                    </Typography>
                  )}
                </label>
              </Grid>
              <Grid item md={12}>
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  {selectedImage !== "" && (
                    <Box sx={{ flexShrink: 0, position: "relative" }}>
                      <CardMedia
                        component={"img"}
                        image={baseUrl + selectedImage}
                        sx={{
                          height: "150px",
                          width: "150px",
                        }}
                      />
                      <IconButton
                        component="span"
                        disableRipple
                        sx={{
                          position: "absolute",
                          right: "-6px",
                          top: "-6px",
                          padding: "1px",
                        }}
                        onClick={() => setSelectedImage("")}
                      >
                        <Close sx={{ color: colors.danger }} />
                      </IconButton>
                    </Box>
                  )}
                </Box>
              </Grid>
            </Grid>
            <Box
              sx={{
                mt: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <PrimaryButton
                data-testId="save-btn"
                title={"Create"}
                type="submit"
                loading={loading}
              />
            </Box>
          </Typography>
        </Box>
      </Box>
    </Fragment>
  );
}

export default CreateCategory;
